import React from 'react';
import { cn } from 'utils/helpers';

type Props = {
  day: string;
  isSelected: boolean;
  onSelect: () => void;
};

const DayItem: React.FC<Props> = ({ day, isSelected, onSelect }) => {
  const handleClick = () => {
    onSelect();
  };

  return (
    <div
      className={cn(
        'flex flex-col bg-[#32395E] gap-2 px-4 py-3 rounded-full transition-all duration-300 cursor-pointer',
        isSelected && 'bg-[#ABE49C] text-black',
      )}
      onClick={handleClick}
    >
      <div className="text-[0.875rem] font-semibold">{day}</div>
    </div>
  );
};

export default DayItem;
